import Drawer from "@material-ui/core/Drawer";
import { makeStyles } from "@material-ui/core/styles";
import React, { useContext, useState } from "react";
import TicketDetailView from "../../components/tickets/TicketDetailView";
import TicketsListView from "../../components/tickets/TicketsListView";
import { MobileContext } from "../Mobile";

const drawerWidth = "100vw";

const useStyles = makeStyles(theme => ({
  menuButton: {
    marginRight: theme.spacing(2)
  },
  searchButton: {
    marginLeft: theme.spacing(2)
  },
  filterButton: {
    marginLeft: theme.spacing(2)
  },
  title: {
    flexGrow: 1
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fafafa"
  }
}));

const Tasks = () => {
  const classes = useStyles();
  const { onDrawerOpen } = useContext(MobileContext);
  const [ticket, setTicket] = useState(null);

  const selectTicket = ticket => {
    setTicket(ticket);
  };

  return (
    <>
      <Drawer
        className={classes.drawer}
        open={Boolean(ticket)}
        anchor="right"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <TicketDetailView mobile ticket={ticket} onClose={() => selectTicket(null)} />
      </Drawer>

      <TicketsListView onClick={selectTicket} onDrawerOpen={onDrawerOpen} />
    </>
  );
};

export default Tasks;
